import "./StudentManagement.scss";
import { CustomButton, SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { userExportApi, userListApi } from "services/user";
import useDebounce from "common/UseDebounce";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { userPlaceholder } from "assets/icons";
import findSerialNumber from "utils/findSerialNumber";
import { limitOption, userRoleOptions } from "constants/staticData";
import {
  capitalizeAndJoin,
  firstWordCapital,
  getValueOrFallback,
} from "utils/common";
import DeleteSelectedUser from "./DeleteSelectedUser";
import { useFileDownloader } from "hooks/useFileDownloader";
import { CgBlock, CgUnblock } from "react-icons/cg";
import ChangeSelectedUserStatus from "./ChangeSelectedUserStatus";
import { dateFormat } from "utils/dateFormat";
import { Select } from "common/InputForm";

const GroupManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [imagePreview, setImagePreview] = useState("");
  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [userList, setUserList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [loader, onShow, onHide] = useFullPageLoader();
  const userTypeValue = searchParams.get("userType") || "";
  const activePage = +searchParams.get("page") || 1;
  const limits = +searchParams.get("limit") || 10;
  const [total, setTotal] = useState(null);
  const [selectedUserDetail, setSelectedUserDetail] = useState({});
  const [deleteModel, setDeleteModel] = useState(false);
  const { isLoading, downloadFile } = useFileDownloader();
  const [userStatusModal, setUserStatusModal] = useState(false);
  const [state, setState] = useState({
    status: ""
  });


  // delete handler function
  const userDeleteHandler = (userData) => {
    setDeleteModel(true);
    setSelectedUserDetail(userData);
  };

  // change user Status handler
  const changeUserStatusHandler = (data) => {
    setUserStatusModal(true)
    setSelectedUserDetail(data)
  }

  // show image preview handler
  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };

  //Reset all value
  const resetFilterHandler = () => {
    setState(prev => ({ ...prev, status: "" }))
    searchParams.delete("userType");
    searchParams.delete("page");
    searchParams.delete("limit");
    setSearch("");
    setSearchParams(searchParams);
  };

  // Handle pagination
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  // handle limit of page
  const handleLimit = (event) => {
    searchParams.set("limit", event.target.value);
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  //Handle user role
  const handleUserTypeValue = (event) => {
    if (!event.target.value || event.target.value === "") {
      searchParams.delete("userType");
    } else {
      searchParams.set("userType", event.target.value);
    }
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  // handle file download

  const handleFileDownloader = () => {
    const fileUrl = `${process.env.REACT_APP_API_URL}admin/user/export`;
    const fileName = `user-list-${Date.now()}`;
    downloadFile(fileUrl, fileName);
  };

  // user list handler
  const userListHandler = async (activePage, limits) => {
    try {
      onShow();
      const reqData = {
        pagination: "true",
        page: activePage,
        limit: limits,
        ...(search && debouncedValue && { search: debouncedValue }),
        ...(state.status && { status: state.status }),
      };
      const { data, status } = await userListApi(reqData);
      if (status === 200) {
        setTotal(data?.meta.totalRecords);
        setUserList(data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };


  // user list handler
  const userExportHandler = async () => {
    try {
      onShow();
      const reqData = {};
      await userExportApi(reqData);
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  // on close
  const onClose = () => {
    setSelectedUserDetail({});
    setUserStatusModal(false);
    setDeleteModel(false);
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    userListHandler(activePage, limits);
  }, [searchParams, activePage, debouncedValue, userTypeValue, limits, state.status]);

  useEffect(() => {
    if (debouncedValue) {
      searchParams.delete("page");
    }
  }, [debouncedValue]);

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>User Management</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search"}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />

            <Select
              name="status"
              onChange={e => setState(prev => ({ ...prev, status: e.target.value }))}
              value={state.status}
            >
              <option value="">Status</option>
              <option value="ACTIVE">Unblock User</option>
              <option value="INACTIVE">Block User</option>
            </Select>

            <CustomButton
              type="button"
              className="button"
              onClick={() => handleFileDownloader()}
              isDisabled={isLoading || userList.length === 0}
              isLoading={isLoading}
            >
              Export
            </CustomButton>
            <CustomButton onClick={resetFilterHandler}>
              <SlRefresh />
            </CustomButton>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No</th>
                    <th className="nowrap text-center">Profile</th>
                    <th className="nowrap text-center">Name</th>
                    <th className="nowrap text-center">Date of Birth</th>
                    <th className="nowrap text-center">Mobile Number</th>
                    <th className="nowrap text-center">Email</th>
                    <th className="nowrap text-center">Joined Groups</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {userList && userList.length ? (
                    userList?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="nowrap text-center">
                            {findSerialNumber(index, activePage, limits)}
                          </td>
                          <td className="nowrap text-center">
                            <img
                              src={(data?.profilePicture?.length && data?.profilePicture?.length > 50) ? data?.profilePicture : userPlaceholder}
                              alt="user-profile-image"
                              className="avatar"
                              onClick={() =>
                                showImagePreviewHandler(data?.profilePicture)
                              }
                            />
                          </td>
                          <td className="nowrap text-center text-capitalize">
                            {firstWordCapital(data?.fullName || "---")}
                          </td>
                          <td className="nowrap text-center">
                            {dateFormat(data?.dateOfBirth)}
                          </td>
                          <td className="nowrap text-center">
                            {(data?.contact?.mobileNumber?.dialCode || "") + "-" + (data?.contact?.mobileNumber?.number || "---")}
                          </td>
                          <td className="nowrap text-center">
                            {getValueOrFallback(data?.contact?.email)}
                          </td>
                          <td className="nowrap text-center">
                            0
                          </td>
                          <td>
                            <div className="icon_wrap">
                              <Link
                                to={`user-detail/${data._id}`}
                                className="icon_button"
                              >
                                <FaEye />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  changeUserStatusHandler(data);
                                }}
                              >
                                {data.status === "ACTIVE" ? (
                                  <CgBlock style={{ color: "red" }} />
                                ) : (
                                  <CgUnblock />
                                )}
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={10}
                      msg={"User Data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limits}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete User */}
      {deleteModel && (
        <DeleteSelectedUser
          selectedUserDetail={selectedUserDetail}
          onClose={() => onClose()}
          setUserList={setUserList}
          deleteModel={deleteModel}
        />
      )}

      {/* Change User Status*/}
      {userStatusModal && (
        <ChangeSelectedUserStatus
          selectedUserDetail={selectedUserDetail}
          onClose={() => onClose()}
          setUserList={setUserList}
          userStatusModal={userStatusModal}
          refetchUserList={() => userListHandler(activePage, limits)}
        />
      )}

      {/* Image Preview model */}
      <CustomModal
        className={"sm image_preview_modal"}
        show={showImagePreviewModel}
        handleClose={() => {
          setImagePreview("");
          setShowImagePreviewModel(false);
        }}
      >
        <div className="image_preview">
          <img
            src={imagePreview || userPlaceholder}
            alt="user-profile-preview"
          />
        </div>
      </CustomModal>
    </>
  );
};

export default GroupManagement;
